import {ColDef} from "ag-grid-community";
import {IRecoveryEditGrantsForm} from "../models/models";

export const EXPIRED_DEFAULT_COL_DEF: ColDef = {
    resizable: true,
    lockPinned: true,
    unSortIcon: true,
    suppressSizeToFit: true
};

export const RECOVERY_EDIT_GRANTS_FORM_INITIAL_VALUES: IRecoveryEditGrantsForm = {
    dms: [],
    flagBookingRecovery: false,
    flagRaRecovery: false,
    flagCheckInRecovery: false,
    flagSignRecovery: false,
    flagBookingSubstitutionRecovery: false
}